import React from "react";
import { Helmet } from "react-helmet";

const clients = [
  "Central Asia Regional Cooperation (CAREC) - 11 Countries Regional Organization, China",
  "World Bank, Pakistan",
  "FAO, Pakistan",
  "International Alert, Pakistan (INGO)",
  "Pakistan Tobacco Company Limited",
  "Telenor Pakistan (Private) Limited",
  "DG Khan Cement Limited",
  "Habib ADM (Private) Limited",
  "Suraj Fertilizer (Private) Limited",
  "Imperial Management (Private) Limited (Falettis Hotel, Lahore)",
  "Pakistan Telecommunication Authority",
  "PEMRA",
  "Trade Development Authority",
  "Overseas Pakistanis Foundation",
  "PRIMACO",
  "Trading Corporation of Pakistan (TCP)",
  "Pakistan Cricket Board (PCB)",
  "Punjab Revenue Authority",
  "Matora (Private) Limited",
  "Arooj Textiles (Private) Limited",
  "Rai Textiles (Private) Limited",
  "Deli JW Glassware Company Limited",
  "Tricon Limited",
  "Allied Developers",
  "Al-Razi (Private) Limited",
  "LTHJV",
  "ATECS Pakistan",
  "SISA, Lahore",
  "Master Tiles, Gujranwala",
  "AFCO Steel Industries",
  "Mughal Iron & Steel",
  "Hattar Steel Re-Rolling",
  "Master Pipe Industries",
  "Irfan Industries (Private) Limited",
  "Shah Sons Pakistan (Private) Limited",
  "M. Shah Muhammad & Sons (Private) Limited",
  "Chicago Metal Works (Private) Limited",
  "Net Com (Private) Limited",
  "Ali Steel (Private) Limited",
  "Nauman Steel",
  "Mobil Master (Private) Limited",
  "Modern Pipe Industries",
  "H.H Industries",
  "Smat Steel (Private) Limited",
  "Sun Tube (Private) Limited",
  "Sergio (Private) Limited",
  "SM Riaz (Private) Limited",
  "SM Ilyas (Private) Limited",
  "A & A Pipe Industries",
  "Kamran Steel Industries",
  "Bashir Pipe Industries",
  "Hamza Industries",
  "Telecard Limited",
  "Nadia Steel (Private) Limited",
  "Yaqub Steel (Private) Limited",
  "FAS Tube & Engineering (Private) Limited",
  "SM Riaz (Private) Limited",
  "Bakhtawar Traders",
  "SK Pipe Industries",
  "Inayat Pipe Industries",
  "Hamza Industries",
  "AN Industries (Private) Limited",
  "Care Plastic Industries",
  "Bilal Steel Mills (Private) Limited",
  "Shalimar Steel Re-Rolling",
  "S.J Steel Re-Rolling",
  "Icon Corporation",
  "Time Business Aids",
  "World Wide Traders",
];

const Clientele = () => {
  return (
    <section className="clientele-page">
      <Helmet>
        <title>Clientele | DeJure Law & Consulting</title>
        <meta
          name="description"
          content="DeJure Advocates & Legal Consultants partners with leading public, private, and international organizations across Pakistan and beyond."
        />
      </Helmet>

      {/* Hero: background image with overlay + text on top */}
      <div className="container-fluid clientele-hero">
        <picture className="clientele-hero-picture">
          <source
            type="image/webp"
            srcSet="/assets/clients/clients-lawyer1-320.webp 320w, /assets/clients/clients-lawyer1-640.webp 640w, /assets/clients/clients-lawyer1-1280.webp 1280w, /assets/clients/clients-lawyer1-1920.webp 1920w"
            sizes="(max-width: 768px) 100vw, 50vw"
          />
          <source
            type="image/jpeg"
            srcSet="/assets/clients/clients-lawyer1-320.jpg 320w, /assets/clients/clients-lawyer1-640.jpg 640w, /assets/clients/clients-lawyer1-1280.jpg 1280w, /assets/clients/clients-lawyer1-1920.jpg 1920w"
            sizes="(max-width: 768px) 100vw, 50vw"
          />
          <img
            src="/assets/clients/clients-lawyer1-1280.jpg"
            alt=""
            aria-hidden="true"
            className="clientele-hero-img"
            loading="eager"
          />
        </picture>
        <div className="clientele-hero-overlay" aria-hidden="true"></div>
        <div className="container">
          <div className="row">
            <div className="col-12 col-lg-8">
              <div className="clientele-hero-content">
                <h6 className="guide-text text-uppercase text-light">Clientele</h6>
                <h1 className="clientele-heading text-light">Our Clients</h1>
                <p className="clientele-lead text-light">
                  The foundation of a successful law firm is built on strong relationships — with
                  clients, the community, and the legal profession. We regularly serve both public and
                  private sector organizations and have the privilege of advising international bodies on
                  complex mandates. A representative list includes:
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Clients list */}
      <div className="container py-4">
        <div className="row justify-content-center">
          <div className="col-12 col-lg-10">
            <ul className="client-list list-unstyled row row-cols-1 row-cols-md-2 row-cols-xl-3 g-3 pt-3">
              {clients.map((client, index) => (
                <li className="col" key={`${client}-${index}`}>
                  <div className="client-card h-100">{client}</div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Clientele;
